import { useNavigate } from 'react-router-dom'
import { FormClientes } from '../../../components/Forms/FormClientes'
import Navbar from '../../../components/navbar/navbar'
import { useRef, useState } from 'react'
import PessoasService from '../../../services/database/PessoasService'
import { toast } from 'react-toastify'

export function NovoCliente() {
  const [isCustomerCreateLoading, setIsCustomerCreateLoading] = useState(false)

  const navigate = useNavigate()

  function handleNavigate() {
    navigate(-1)
  }

  async function handleSubmit(e) {
    e.preventDefault()

    setIsCustomerCreateLoading(true)

    try {
      const customer = formClientesRef.current?.getCustomer()

      await PessoasService.create(customer)

      toast.success('Cliente cadastrado com sucesso!')

      handleNavigate()
    } catch (err) {
      console.log(`Erro ao cadastrar o cliente: ${err}`)
      return toast.error('Erro ao cadastrar o cliente!')
    } finally {
      setIsCustomerCreateLoading(false)
    }
  }

  const formClientesRef = useRef(null)

  return (
    <>
      <div className="mt-page">
        <Navbar />

        <FormClientes
          ref={formClientesRef}
          title="Cadastrar Cliente"
          onBack={handleNavigate}
          onSubmit={handleSubmit}
          isRequestLoading={isCustomerCreateLoading}
        />
      </div>
    </>
  )
}
